import { render, staticRenderFns } from "./TradeMark.vue?vue&type=template&id=0d22fd24&scoped=true"
import script from "./TradeMark.vue?vue&type=script&lang=js"
export * from "./TradeMark.vue?vue&type=script&lang=js"
import style0 from "./TradeMark.vue?vue&type=style&index=0&id=0d22fd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22fd24",
  null
  
)

export default component.exports